var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.permissionsArray.includes("can_manage_users")
    ? _c(
        "div",
        {
          staticClass: "admin-content-area dashboard",
          attrs: { id: "page-content-wrapper" }
        },
        [
          _c("div", { staticClass: "container-fluid xyz location-listing" }, [
            _c(
              "div",
              {
                staticClass: "page-header-top-container",
                staticStyle: { position: "fixed" }
              },
              [
                _c(
                  "div",
                  { staticClass: "page-name", staticStyle: { width: "40%" } },
                  [_vm._v(_vm._s(_vm.customer_name) + " Inventory")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary waves-effect pull-right",
                    attrs: { type: "submit" },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.backToCustomerList()
                      }
                    }
                  },
                  [_vm._v("Back")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary waves-effect pull-right",
                    attrs: { type: "submit" },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.AddPart()
                      }
                    }
                  },
                  [_vm._v("Add Part")]
                ),
                _vm._v(" "),
                _vm.isNonVVGDealer == "NO"
                  ? [
                      _vm.syncButtonShow
                        ? [
                            _c(
                              "button",
                              {
                                staticClass:
                                  "btn btn-primary waves-effect pull-right",
                                attrs: {
                                  type: "submit",
                                  id: "syncCustomerParts"
                                },
                                on: {
                                  click: function($event) {
                                    $event.preventDefault()
                                    return _vm.syncPart()
                                  }
                                }
                              },
                              [_vm._v("Sync Parts")]
                            )
                          ]
                        : _vm._e()
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary waves-effect pull-right",
                    attrs: {
                      disabled: _vm.disableButtons.export,
                      type: "submit"
                    },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.loadInventoryParts(true)
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.buttonNames.export))]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary waves-effect pull-right",
                    attrs: {
                      disabled: _vm.disableButtons.import,
                      type: "submit"
                    },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.importInventoryParts(true)
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.buttonNames.import))]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass:
                      "extraFeature btn btn-primary waves-effect pull-right ml-2",
                    attrs: {
                      type: "submit",
                      id: "refreshList",
                      title: "Refresh"
                    },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.loadInventoryParts()
                      }
                    }
                  },
                  [
                    _c("i", {
                      staticClass: "fa fa-rotate-right",
                      attrs: { "aria-hidden": "true" }
                    })
                  ]
                )
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "admin-page-content",
                staticStyle: { "padding-top": "100px" }
              },
              [
                _c("div", { staticClass: "clearfix" }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    class:
                      "app-filter-good-table-container cust-inventory-margin text-align-placeholder-customer-inventory " +
                      _vm.countryBaseClass
                  },
                  [
                    _c("vue-good-table", {
                      ref: "listInventory",
                      attrs: {
                        mode: "remote",
                        title: "Inventory",
                        "row-style-class": _vm.rowStyleClassFn,
                        totalRows: _vm.totalRecords,
                        columns: _vm.columns,
                        rows: _vm.rows,
                        selectOptions: {
                          enabled: true,
                          selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                          selectionInfoClass: "custom-class",
                          selectionText: "rows selected",
                          clearSelectionText: "clear"
                        },
                        "pagination-options": {
                          enabled: true,
                          mode: "pages",
                          pageLabel: "Page",
                          position: "both",
                          perPage: _vm.serverParams.perPage,
                          setCurrentPage: _vm.serverParams.setCurrentPage,
                          perPageDropdown: [25, 50, 100, 200, 500],
                          dropdownAllowAll: false
                        },
                        "search-options": {
                          enabled: false
                        }
                      },
                      on: {
                        "on-page-change": _vm.onPageChange,
                        "on-column-filter": _vm.onColumnFilter,
                        "on-per-page-change": _vm.onPerPageChange,
                        "on-sort-change": _vm.onSortChange,
                        "on-selected-rows-change": _vm.selectionChanged,
                        "on-cell-click": _vm.onCellClick
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "pagination-top",
                            fn: function(props) {
                              return [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "vgt-wrap__footer top-pagination crm"
                                  },
                                  [
                                    _c("div", { staticClass: "row" }, [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-sm-12 col-md-2 PerPage"
                                        },
                                        [
                                          _c("v-select", {
                                            attrs: {
                                              title: "Select Per Page",
                                              name: "customPerPage",
                                              id: "customPerPage",
                                              label: "text",
                                              clearable: false,
                                              searchable: false,
                                              filterable: false,
                                              options:
                                                _vm.serverParams
                                                  .perPageDropdown,
                                              placeholder: "Select Per Page"
                                            },
                                            on: {
                                              change: _vm.changedValueTask,
                                              input: function($event) {
                                                return _vm.changedValueTaskCustomPerPageTask()
                                              }
                                            },
                                            model: {
                                              value: _vm.serverParams.perPage,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.serverParams,
                                                  "perPage",
                                                  $$v
                                                )
                                              },
                                              expression: "serverParams.perPage"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "mt-2 col-sm-12 col-md-2 RowsDisplay"
                                        },
                                        [
                                          _c(
                                            "p",
                                            { staticClass: "pageRowCount" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.paginationDisplayRowsTask
                                                ) +
                                                  " of " +
                                                  _vm._s(_vm.totalRecords)
                                              )
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-sm-12 col-md-6 Pagination"
                                        },
                                        [
                                          _c(
                                            "ul",
                                            { staticClass: "pagination" },
                                            [
                                              _c(
                                                "li",
                                                {
                                                  staticClass: "FirstPage",
                                                  attrs: { title: "First Page" }
                                                },
                                                [
                                                  Number(
                                                    _vm.serverParams.page
                                                  ) == 1
                                                    ? [
                                                        _c(
                                                          "a",
                                                          {
                                                            staticClass:
                                                              "page-link",
                                                            attrs: {
                                                              href:
                                                                "javascript:void(0)"
                                                            }
                                                          },
                                                          [_vm._v("1")]
                                                        )
                                                      ]
                                                    : [
                                                        _c(
                                                          "a",
                                                          {
                                                            staticClass:
                                                              "page-link",
                                                            attrs: {
                                                              href:
                                                                "javascript:void(0)"
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.onPerticularPageClickTask(
                                                                  1
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [_vm._v("1")]
                                                        )
                                                      ]
                                                ],
                                                2
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "li",
                                                {
                                                  staticClass:
                                                    "page-item PreviousPage",
                                                  attrs: {
                                                    title: "Previous Page"
                                                  }
                                                },
                                                [
                                                  Number(
                                                    _vm.serverParams.page
                                                  ) == 1
                                                    ? [
                                                        _c(
                                                          "a",
                                                          {
                                                            staticClass:
                                                              "page-link",
                                                            attrs: {
                                                              href:
                                                                "javascript:void(0)",
                                                              tabindex: "-1"
                                                            }
                                                          },
                                                          [
                                                            _c("i", {
                                                              staticClass:
                                                                "fa fa-angle-left"
                                                            })
                                                          ]
                                                        )
                                                      ]
                                                    : [
                                                        _c(
                                                          "a",
                                                          {
                                                            staticClass:
                                                              "page-link",
                                                            attrs: {
                                                              href:
                                                                "javascript:void(0)",
                                                              tabindex: "-1"
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                _vm.onPerticularPageClickTask(
                                                                  Number(
                                                                    _vm
                                                                      .serverParams
                                                                      .page
                                                                  ) - 1
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _c("i", {
                                                              staticClass:
                                                                "fa fa-angle-left"
                                                            })
                                                          ]
                                                        )
                                                      ]
                                                ],
                                                2
                                              ),
                                              _vm._v(" "),
                                              _vm.pageNumberListTask() <
                                              _vm.displayPageTask
                                                ? [
                                                    _vm._l(
                                                      _vm.pageNumberListTask(),
                                                      function(n, index) {
                                                        return [
                                                          n ==
                                                          Number(
                                                            _vm.serverParams
                                                              .page
                                                          )
                                                            ? _c(
                                                                "li",
                                                                {
                                                                  staticClass:
                                                                    "PagesClass page-item active",
                                                                  attrs: {
                                                                    title:
                                                                      "Page " +
                                                                      n,
                                                                    id:
                                                                      "pageNumber" +
                                                                      n
                                                                  }
                                                                },
                                                                [
                                                                  _c(
                                                                    "a",
                                                                    {
                                                                      staticClass:
                                                                        "page-link",
                                                                      attrs: {
                                                                        href:
                                                                          "javascript:void(0)"
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "\n                                                            " +
                                                                          _vm._s(
                                                                            n
                                                                          ) +
                                                                          "\n                                                        "
                                                                      )
                                                                    ]
                                                                  )
                                                                ]
                                                              )
                                                            : _c(
                                                                "li",
                                                                {
                                                                  staticClass:
                                                                    "PagesClass page-item",
                                                                  attrs: {
                                                                    title:
                                                                      "Page " +
                                                                      n,
                                                                    id:
                                                                      "pageNumber" +
                                                                      n
                                                                  },
                                                                  on: {
                                                                    click: function(
                                                                      $event
                                                                    ) {
                                                                      return _vm.onPerticularPageClickTask(
                                                                        n
                                                                      )
                                                                    }
                                                                  }
                                                                },
                                                                [
                                                                  _c(
                                                                    "a",
                                                                    {
                                                                      staticClass:
                                                                        "page-link",
                                                                      attrs: {
                                                                        href:
                                                                          "javascript:void(0)"
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "\n                                                            " +
                                                                          _vm._s(
                                                                            n
                                                                          ) +
                                                                          "\n                                                        "
                                                                      )
                                                                    ]
                                                                  )
                                                                ]
                                                              )
                                                        ]
                                                      }
                                                    )
                                                  ]
                                                : [
                                                    Number(
                                                      _vm.serverParams.page
                                                    ) <= _vm.pageCompareTask
                                                      ? [
                                                          _vm._l(
                                                            _vm.displayPageTask,
                                                            function(n, index) {
                                                              return [
                                                                n ==
                                                                Number(
                                                                  _vm
                                                                    .serverParams
                                                                    .page
                                                                )
                                                                  ? _c(
                                                                      "li",
                                                                      {
                                                                        staticClass:
                                                                          "PagesClass page-item active",
                                                                        attrs: {
                                                                          title:
                                                                            "Page " +
                                                                            n,
                                                                          id:
                                                                            "pageNumber" +
                                                                            n
                                                                        }
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "a",
                                                                          {
                                                                            staticClass:
                                                                              "page-link",
                                                                            attrs: {
                                                                              href:
                                                                                "javascript:void(0)"
                                                                            }
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "\n                                                                " +
                                                                                _vm._s(
                                                                                  n
                                                                                ) +
                                                                                "\n                                                            "
                                                                            )
                                                                          ]
                                                                        )
                                                                      ]
                                                                    )
                                                                  : _c(
                                                                      "li",
                                                                      {
                                                                        staticClass:
                                                                          "PagesClass page-item",
                                                                        attrs: {
                                                                          title:
                                                                            "Page " +
                                                                            n,
                                                                          id:
                                                                            "pageNumber" +
                                                                            n
                                                                        },
                                                                        on: {
                                                                          click: function(
                                                                            $event
                                                                          ) {
                                                                            return _vm.onPerticularPageClickTask(
                                                                              n
                                                                            )
                                                                          }
                                                                        }
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "a",
                                                                          {
                                                                            staticClass:
                                                                              "page-link",
                                                                            attrs: {
                                                                              href:
                                                                                "javascript:void(0)"
                                                                            }
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "\n                                                                " +
                                                                                _vm._s(
                                                                                  n
                                                                                ) +
                                                                                "\n                                                            "
                                                                            )
                                                                          ]
                                                                        )
                                                                      ]
                                                                    )
                                                              ]
                                                            }
                                                          )
                                                        ]
                                                      : Number(
                                                          _vm.serverParams.page
                                                        ) >=
                                                        _vm.pageNumberListTask() -
                                                          (_vm.pageCompareTask -
                                                            1)
                                                      ? [
                                                          _vm._l(
                                                            _vm.pageNumberListTask(),
                                                            function(n, index) {
                                                              return [
                                                                n >
                                                                _vm.pageNumberListTask() -
                                                                  _vm.displayPageTask
                                                                  ? [
                                                                      n ==
                                                                      Number(
                                                                        _vm
                                                                          .serverParams
                                                                          .page
                                                                      )
                                                                        ? _c(
                                                                            "li",
                                                                            {
                                                                              staticClass:
                                                                                "PagesClass page-item active",
                                                                              attrs: {
                                                                                title:
                                                                                  "Page " +
                                                                                  n,
                                                                                id:
                                                                                  "pageNumber" +
                                                                                  n
                                                                              }
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "a",
                                                                                {
                                                                                  staticClass:
                                                                                    "page-link",
                                                                                  attrs: {
                                                                                    href:
                                                                                      "javascript:void(0)"
                                                                                  }
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    "\n                                                                    " +
                                                                                      _vm._s(
                                                                                        n
                                                                                      ) +
                                                                                      "\n                                                                "
                                                                                  )
                                                                                ]
                                                                              )
                                                                            ]
                                                                          )
                                                                        : _c(
                                                                            "li",
                                                                            {
                                                                              staticClass:
                                                                                "PagesClass page-item",
                                                                              attrs: {
                                                                                title:
                                                                                  "Page " +
                                                                                  n,
                                                                                id:
                                                                                  "pageNumber" +
                                                                                  n
                                                                              },
                                                                              on: {
                                                                                click: function(
                                                                                  $event
                                                                                ) {
                                                                                  return _vm.onPerticularPageClickTask(
                                                                                    n
                                                                                  )
                                                                                }
                                                                              }
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "a",
                                                                                {
                                                                                  staticClass:
                                                                                    "page-link",
                                                                                  attrs: {
                                                                                    href:
                                                                                      "javascript:void(0)"
                                                                                  }
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    "\n                                                                    " +
                                                                                      _vm._s(
                                                                                        n
                                                                                      ) +
                                                                                      "\n                                                                "
                                                                                  )
                                                                                ]
                                                                              )
                                                                            ]
                                                                          )
                                                                    ]
                                                                  : _vm._e()
                                                              ]
                                                            }
                                                          )
                                                        ]
                                                      : [
                                                          _vm._l(
                                                            _vm.pageNumberListTask(),
                                                            function(n, index) {
                                                              return n >=
                                                                Number(
                                                                  _vm
                                                                    .serverParams
                                                                    .page
                                                                ) -
                                                                  (_vm.pageCompareTask -
                                                                    1) &&
                                                                n <=
                                                                  Number(
                                                                    _vm
                                                                      .serverParams
                                                                      .page
                                                                  ) +
                                                                    (_vm.pageCompareTask -
                                                                      1)
                                                                ? [
                                                                    n ==
                                                                    Number(
                                                                      _vm
                                                                        .serverParams
                                                                        .page
                                                                    )
                                                                      ? _c(
                                                                          "li",
                                                                          {
                                                                            staticClass:
                                                                              "PagesClass page-item active",
                                                                            attrs: {
                                                                              title:
                                                                                "Page " +
                                                                                n,
                                                                              id:
                                                                                "pageNumber" +
                                                                                n
                                                                            }
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "a",
                                                                              {
                                                                                staticClass:
                                                                                  "page-link",
                                                                                attrs: {
                                                                                  href:
                                                                                    "javascript:void(0)"
                                                                                }
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  "\n                                                                " +
                                                                                    _vm._s(
                                                                                      n
                                                                                    ) +
                                                                                    "\n                                                            "
                                                                                )
                                                                              ]
                                                                            )
                                                                          ]
                                                                        )
                                                                      : _c(
                                                                          "li",
                                                                          {
                                                                            staticClass:
                                                                              "PagesClass page-item",
                                                                            attrs: {
                                                                              title:
                                                                                "Page " +
                                                                                n,
                                                                              id:
                                                                                "pageNumber" +
                                                                                n
                                                                            },
                                                                            on: {
                                                                              click: function(
                                                                                $event
                                                                              ) {
                                                                                return _vm.onPerticularPageClickTask(
                                                                                  n
                                                                                )
                                                                              }
                                                                            }
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "a",
                                                                              {
                                                                                staticClass:
                                                                                  "page-link",
                                                                                attrs: {
                                                                                  href:
                                                                                    "javascript:void(0)"
                                                                                }
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  "\n                                                                " +
                                                                                    _vm._s(
                                                                                      n
                                                                                    ) +
                                                                                    "\n                                                            "
                                                                                )
                                                                              ]
                                                                            )
                                                                          ]
                                                                        )
                                                                  ]
                                                                : _vm._e()
                                                            }
                                                          )
                                                        ]
                                                  ],
                                              _vm._v(" "),
                                              _c(
                                                "li",
                                                {
                                                  staticClass:
                                                    "page-item NextPage",
                                                  attrs: { title: "Next Page" }
                                                },
                                                [
                                                  Number(
                                                    _vm.serverParams.page
                                                  ) == _vm.pageNumberListTask()
                                                    ? [
                                                        _c(
                                                          "a",
                                                          {
                                                            staticClass:
                                                              "page-link",
                                                            attrs: {
                                                              href:
                                                                "javascript:void(0)"
                                                            }
                                                          },
                                                          [
                                                            _c("i", {
                                                              staticClass:
                                                                "fa fa-angle-right"
                                                            })
                                                          ]
                                                        )
                                                      ]
                                                    : [
                                                        _c(
                                                          "a",
                                                          {
                                                            staticClass:
                                                              "page-link",
                                                            attrs: {
                                                              href:
                                                                "javascript:void(0)"
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                _vm.onPerticularPageClickTask(
                                                                  Number(
                                                                    _vm
                                                                      .serverParams
                                                                      .page
                                                                  ) + 1
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _c("i", {
                                                              staticClass:
                                                                "fa fa-angle-right"
                                                            })
                                                          ]
                                                        )
                                                      ]
                                                ],
                                                2
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "li",
                                                {
                                                  staticClass: "LastPage",
                                                  attrs: { title: "Last Page" }
                                                },
                                                [
                                                  Number(
                                                    _vm.serverParams.page
                                                  ) == _vm.pageNumberListTask()
                                                    ? [
                                                        _c(
                                                          "a",
                                                          {
                                                            staticClass:
                                                              "page-link",
                                                            attrs: {
                                                              href:
                                                                "javascript:void(0)",
                                                              tabindex: "-1"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.pageNumberListTask()
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    : [
                                                        _c(
                                                          "a",
                                                          {
                                                            staticClass:
                                                              "page-link",
                                                            attrs: {
                                                              href:
                                                                "javascript:void(0)",
                                                              tabindex: "-1"
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                _vm.onPerticularPageClickTask(
                                                                  _vm.pageNumberListTask()
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.pageNumberListTask()
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                ],
                                                2
                                              )
                                            ],
                                            2
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "mt-2 col-lg-1 col-md-1 col-sm-2 col-xs-6"
                                        },
                                        [
                                          _c(
                                            "p",
                                            { staticClass: "pageJumpLabel" },
                                            [_vm._v("Page : ")]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "mt-1 col-lg-1 col-md-1 col-sm-2 col-xs-6"
                                        },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.jumpToPageTask,
                                                expression: "jumpToPageTask"
                                              }
                                            ],
                                            staticClass:
                                              "form-control form-control-sm",
                                            attrs: {
                                              type: "text",
                                              name: "jumpToPageTask",
                                              id: "jumpToPageTask",
                                              placeholder: "Page"
                                            },
                                            domProps: {
                                              value: _vm.jumpToPageTask
                                            },
                                            on: {
                                              keyup: function($event) {
                                                if (
                                                  !$event.type.indexOf("key") &&
                                                  _vm._k(
                                                    $event.keyCode,
                                                    "enter",
                                                    13,
                                                    $event.key,
                                                    "Enter"
                                                  )
                                                ) {
                                                  return null
                                                }
                                                return _vm.jumpToPageInTask.apply(
                                                  null,
                                                  arguments
                                                )
                                              },
                                              input: function($event) {
                                                if ($event.target.composing) {
                                                  return
                                                }
                                                _vm.jumpToPageTask =
                                                  $event.target.value
                                              }
                                            }
                                          })
                                        ]
                                      )
                                    ])
                                  ]
                                )
                              ]
                            }
                          },
                          {
                            key: "pagination-bottom",
                            fn: function(props) {
                              return [
                                _c(
                                  "div",
                                  { staticClass: "vgt-wrap__footer crm" },
                                  [
                                    _c("div", { staticClass: "row" }, [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-sm-12 col-md-2 PerPage"
                                        },
                                        [
                                          _c("v-select", {
                                            attrs: {
                                              title: "Select Per Page",
                                              name: "customPerPage",
                                              id: "customPerPage",
                                              label: "text",
                                              clearable: false,
                                              searchable: false,
                                              filterable: false,
                                              options:
                                                _vm.serverParams
                                                  .perPageDropdown,
                                              placeholder: "Select Per Page"
                                            },
                                            on: {
                                              change: _vm.changedValueTask,
                                              input: function($event) {
                                                return _vm.changedValueTaskCustomPerPageTask()
                                              }
                                            },
                                            model: {
                                              value: _vm.serverParams.perPage,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.serverParams,
                                                  "perPage",
                                                  $$v
                                                )
                                              },
                                              expression: "serverParams.perPage"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "mt-2 col-sm-12 col-md-2 RowsDisplay"
                                        },
                                        [
                                          _c(
                                            "p",
                                            { staticClass: "pageRowCount" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.paginationDisplayRowsTask
                                                ) +
                                                  " of " +
                                                  _vm._s(_vm.totalRecords)
                                              )
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-sm-12 col-md-6 Pagination"
                                        },
                                        [
                                          _c(
                                            "ul",
                                            { staticClass: "pagination" },
                                            [
                                              _c(
                                                "li",
                                                {
                                                  staticClass: "FirstPage",
                                                  attrs: { title: "First Page" }
                                                },
                                                [
                                                  Number(
                                                    _vm.serverParams.page
                                                  ) == 1
                                                    ? [
                                                        _c(
                                                          "a",
                                                          {
                                                            staticClass:
                                                              "page-link",
                                                            attrs: {
                                                              href:
                                                                "javascript:void(0)"
                                                            }
                                                          },
                                                          [_vm._v("1")]
                                                        )
                                                      ]
                                                    : [
                                                        _c(
                                                          "a",
                                                          {
                                                            staticClass:
                                                              "page-link",
                                                            attrs: {
                                                              href:
                                                                "javascript:void(0)"
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.onPerticularPageClickTask(
                                                                  1
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [_vm._v("1")]
                                                        )
                                                      ]
                                                ],
                                                2
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "li",
                                                {
                                                  staticClass:
                                                    "page-item PreviousPage",
                                                  attrs: {
                                                    title: "Previous Page"
                                                  }
                                                },
                                                [
                                                  Number(
                                                    _vm.serverParams.page
                                                  ) == 1
                                                    ? [
                                                        _c(
                                                          "a",
                                                          {
                                                            staticClass:
                                                              "page-link",
                                                            attrs: {
                                                              href:
                                                                "javascript:void(0)",
                                                              tabindex: "-1"
                                                            }
                                                          },
                                                          [
                                                            _c("i", {
                                                              staticClass:
                                                                "fa fa-angle-left"
                                                            })
                                                          ]
                                                        )
                                                      ]
                                                    : [
                                                        _c(
                                                          "a",
                                                          {
                                                            staticClass:
                                                              "page-link",
                                                            attrs: {
                                                              href:
                                                                "javascript:void(0)",
                                                              tabindex: "-1"
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                _vm.onPerticularPageClickTask(
                                                                  Number(
                                                                    _vm
                                                                      .serverParams
                                                                      .page
                                                                  ) - 1
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _c("i", {
                                                              staticClass:
                                                                "fa fa-angle-left"
                                                            })
                                                          ]
                                                        )
                                                      ]
                                                ],
                                                2
                                              ),
                                              _vm._v(" "),
                                              _vm.pageNumberListTask() <
                                              _vm.displayPageTask
                                                ? [
                                                    _vm._l(
                                                      _vm.pageNumberListTask(),
                                                      function(n, index) {
                                                        return [
                                                          n ==
                                                          Number(
                                                            _vm.serverParams
                                                              .page
                                                          )
                                                            ? _c(
                                                                "li",
                                                                {
                                                                  staticClass:
                                                                    "PagesClass page-item active",
                                                                  attrs: {
                                                                    title:
                                                                      "Page " +
                                                                      n,
                                                                    id:
                                                                      "pageNumber" +
                                                                      n
                                                                  }
                                                                },
                                                                [
                                                                  _c(
                                                                    "a",
                                                                    {
                                                                      staticClass:
                                                                        "page-link",
                                                                      attrs: {
                                                                        href:
                                                                          "javascript:void(0)"
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                                          _vm._s(
                                                                            n
                                                                          ) +
                                                                          "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t"
                                                                      )
                                                                    ]
                                                                  )
                                                                ]
                                                              )
                                                            : _c(
                                                                "li",
                                                                {
                                                                  staticClass:
                                                                    "PagesClass page-item",
                                                                  attrs: {
                                                                    title:
                                                                      "Page " +
                                                                      n,
                                                                    id:
                                                                      "pageNumber" +
                                                                      n
                                                                  },
                                                                  on: {
                                                                    click: function(
                                                                      $event
                                                                    ) {
                                                                      return _vm.onPerticularPageClickTask(
                                                                        n
                                                                      )
                                                                    }
                                                                  }
                                                                },
                                                                [
                                                                  _c(
                                                                    "a",
                                                                    {
                                                                      staticClass:
                                                                        "page-link",
                                                                      attrs: {
                                                                        href:
                                                                          "javascript:void(0)"
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                                          _vm._s(
                                                                            n
                                                                          ) +
                                                                          "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t"
                                                                      )
                                                                    ]
                                                                  )
                                                                ]
                                                              )
                                                        ]
                                                      }
                                                    )
                                                  ]
                                                : [
                                                    Number(
                                                      _vm.serverParams.page
                                                    ) <= _vm.pageCompareTask
                                                      ? [
                                                          _vm._l(
                                                            _vm.displayPageTask,
                                                            function(n, index) {
                                                              return [
                                                                n ==
                                                                Number(
                                                                  _vm
                                                                    .serverParams
                                                                    .page
                                                                )
                                                                  ? _c(
                                                                      "li",
                                                                      {
                                                                        staticClass:
                                                                          "PagesClass page-item active",
                                                                        attrs: {
                                                                          title:
                                                                            "Page " +
                                                                            n,
                                                                          id:
                                                                            "pageNumber" +
                                                                            n
                                                                        }
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "a",
                                                                          {
                                                                            staticClass:
                                                                              "page-link",
                                                                            attrs: {
                                                                              href:
                                                                                "javascript:void(0)"
                                                                            }
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                                                _vm._s(
                                                                                  n
                                                                                ) +
                                                                                "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t"
                                                                            )
                                                                          ]
                                                                        )
                                                                      ]
                                                                    )
                                                                  : _c(
                                                                      "li",
                                                                      {
                                                                        staticClass:
                                                                          "PagesClass page-item",
                                                                        attrs: {
                                                                          title:
                                                                            "Page " +
                                                                            n,
                                                                          id:
                                                                            "pageNumber" +
                                                                            n
                                                                        },
                                                                        on: {
                                                                          click: function(
                                                                            $event
                                                                          ) {
                                                                            return _vm.onPerticularPageClickTask(
                                                                              n
                                                                            )
                                                                          }
                                                                        }
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "a",
                                                                          {
                                                                            staticClass:
                                                                              "page-link",
                                                                            attrs: {
                                                                              href:
                                                                                "javascript:void(0)"
                                                                            }
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                                                _vm._s(
                                                                                  n
                                                                                ) +
                                                                                "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t"
                                                                            )
                                                                          ]
                                                                        )
                                                                      ]
                                                                    )
                                                              ]
                                                            }
                                                          )
                                                        ]
                                                      : Number(
                                                          _vm.serverParams.page
                                                        ) >=
                                                        _vm.pageNumberListTask() -
                                                          (_vm.pageCompareTask -
                                                            1)
                                                      ? [
                                                          _vm._l(
                                                            _vm.pageNumberListTask(),
                                                            function(n, index) {
                                                              return [
                                                                n >
                                                                _vm.pageNumberListTask() -
                                                                  _vm.displayPageTask
                                                                  ? [
                                                                      n ==
                                                                      Number(
                                                                        _vm
                                                                          .serverParams
                                                                          .page
                                                                      )
                                                                        ? _c(
                                                                            "li",
                                                                            {
                                                                              staticClass:
                                                                                "PagesClass page-item active",
                                                                              attrs: {
                                                                                title:
                                                                                  "Page " +
                                                                                  n,
                                                                                id:
                                                                                  "pageNumber" +
                                                                                  n
                                                                              }
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "a",
                                                                                {
                                                                                  staticClass:
                                                                                    "page-link",
                                                                                  attrs: {
                                                                                    href:
                                                                                      "javascript:void(0)"
                                                                                  }
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                                                      _vm._s(
                                                                                        n
                                                                                      ) +
                                                                                      "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t"
                                                                                  )
                                                                                ]
                                                                              )
                                                                            ]
                                                                          )
                                                                        : _c(
                                                                            "li",
                                                                            {
                                                                              staticClass:
                                                                                "PagesClass page-item",
                                                                              attrs: {
                                                                                title:
                                                                                  "Page " +
                                                                                  n,
                                                                                id:
                                                                                  "pageNumber" +
                                                                                  n
                                                                              },
                                                                              on: {
                                                                                click: function(
                                                                                  $event
                                                                                ) {
                                                                                  return _vm.onPerticularPageClickTask(
                                                                                    n
                                                                                  )
                                                                                }
                                                                              }
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "a",
                                                                                {
                                                                                  staticClass:
                                                                                    "page-link",
                                                                                  attrs: {
                                                                                    href:
                                                                                      "javascript:void(0)"
                                                                                  }
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                                                      _vm._s(
                                                                                        n
                                                                                      ) +
                                                                                      "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t"
                                                                                  )
                                                                                ]
                                                                              )
                                                                            ]
                                                                          )
                                                                    ]
                                                                  : _vm._e()
                                                              ]
                                                            }
                                                          )
                                                        ]
                                                      : [
                                                          _vm._l(
                                                            _vm.pageNumberListTask(),
                                                            function(n, index) {
                                                              return n >=
                                                                Number(
                                                                  _vm
                                                                    .serverParams
                                                                    .page
                                                                ) -
                                                                  (_vm.pageCompareTask -
                                                                    1) &&
                                                                n <=
                                                                  Number(
                                                                    _vm
                                                                      .serverParams
                                                                      .page
                                                                  ) +
                                                                    (_vm.pageCompareTask -
                                                                      1)
                                                                ? [
                                                                    n ==
                                                                    Number(
                                                                      _vm
                                                                        .serverParams
                                                                        .page
                                                                    )
                                                                      ? _c(
                                                                          "li",
                                                                          {
                                                                            staticClass:
                                                                              "PagesClass page-item active",
                                                                            attrs: {
                                                                              title:
                                                                                "Page " +
                                                                                n,
                                                                              id:
                                                                                "pageNumber" +
                                                                                n
                                                                            }
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "a",
                                                                              {
                                                                                staticClass:
                                                                                  "page-link",
                                                                                attrs: {
                                                                                  href:
                                                                                    "javascript:void(0)"
                                                                                }
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                                                    _vm._s(
                                                                                      n
                                                                                    ) +
                                                                                    "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t"
                                                                                )
                                                                              ]
                                                                            )
                                                                          ]
                                                                        )
                                                                      : _c(
                                                                          "li",
                                                                          {
                                                                            staticClass:
                                                                              "PagesClass page-item",
                                                                            attrs: {
                                                                              title:
                                                                                "Page " +
                                                                                n,
                                                                              id:
                                                                                "pageNumber" +
                                                                                n
                                                                            },
                                                                            on: {
                                                                              click: function(
                                                                                $event
                                                                              ) {
                                                                                return _vm.onPerticularPageClickTask(
                                                                                  n
                                                                                )
                                                                              }
                                                                            }
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "a",
                                                                              {
                                                                                staticClass:
                                                                                  "page-link",
                                                                                attrs: {
                                                                                  href:
                                                                                    "javascript:void(0)"
                                                                                }
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                                                    _vm._s(
                                                                                      n
                                                                                    ) +
                                                                                    "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t"
                                                                                )
                                                                              ]
                                                                            )
                                                                          ]
                                                                        )
                                                                  ]
                                                                : _vm._e()
                                                            }
                                                          )
                                                        ]
                                                  ],
                                              _vm._v(" "),
                                              _c(
                                                "li",
                                                {
                                                  staticClass:
                                                    "page-item NextPage",
                                                  attrs: { title: "Next Page" }
                                                },
                                                [
                                                  Number(
                                                    _vm.serverParams.page
                                                  ) == _vm.pageNumberListTask()
                                                    ? [
                                                        _c(
                                                          "a",
                                                          {
                                                            staticClass:
                                                              "page-link",
                                                            attrs: {
                                                              href:
                                                                "javascript:void(0)"
                                                            }
                                                          },
                                                          [
                                                            _c("i", {
                                                              staticClass:
                                                                "fa fa-angle-right"
                                                            })
                                                          ]
                                                        )
                                                      ]
                                                    : [
                                                        _c(
                                                          "a",
                                                          {
                                                            staticClass:
                                                              "page-link",
                                                            attrs: {
                                                              href:
                                                                "javascript:void(0)"
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                _vm.onPerticularPageClickTask(
                                                                  Number(
                                                                    _vm
                                                                      .serverParams
                                                                      .page
                                                                  ) + 1
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _c("i", {
                                                              staticClass:
                                                                "fa fa-angle-right"
                                                            })
                                                          ]
                                                        )
                                                      ]
                                                ],
                                                2
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "li",
                                                {
                                                  staticClass: "LastPage",
                                                  attrs: { title: "Last Page" }
                                                },
                                                [
                                                  Number(
                                                    _vm.serverParams.page
                                                  ) == _vm.pageNumberListTask()
                                                    ? [
                                                        _c(
                                                          "a",
                                                          {
                                                            staticClass:
                                                              "page-link",
                                                            attrs: {
                                                              href:
                                                                "javascript:void(0)",
                                                              tabindex: "-1"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.pageNumberListTask()
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    : [
                                                        _c(
                                                          "a",
                                                          {
                                                            staticClass:
                                                              "page-link",
                                                            attrs: {
                                                              href:
                                                                "javascript:void(0)",
                                                              tabindex: "-1"
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                _vm.onPerticularPageClickTask(
                                                                  _vm.pageNumberListTask()
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.pageNumberListTask()
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                ],
                                                2
                                              )
                                            ],
                                            2
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "mt-2 col-lg-1 col-md-1 col-sm-2 col-xs-6"
                                        },
                                        [
                                          _c(
                                            "p",
                                            { staticClass: "pageJumpLabel" },
                                            [_vm._v("Page : ")]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "mt-1 col-lg-1 col-md-1 col-sm-2 col-xs-6"
                                        },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.jumpToPageTask,
                                                expression: "jumpToPageTask"
                                              }
                                            ],
                                            staticClass:
                                              "form-control form-control-sm",
                                            attrs: {
                                              type: "text",
                                              name: "jumpToPageTask",
                                              id: "jumpToPageTask",
                                              placeholder: "Page"
                                            },
                                            domProps: {
                                              value: _vm.jumpToPageTask
                                            },
                                            on: {
                                              keyup: function($event) {
                                                if (
                                                  !$event.type.indexOf("key") &&
                                                  _vm._k(
                                                    $event.keyCode,
                                                    "enter",
                                                    13,
                                                    $event.key,
                                                    "Enter"
                                                  )
                                                ) {
                                                  return null
                                                }
                                                return _vm.jumpToPageInTask.apply(
                                                  null,
                                                  arguments
                                                )
                                              },
                                              input: function($event) {
                                                if ($event.target.composing) {
                                                  return
                                                }
                                                _vm.jumpToPageTask =
                                                  $event.target.value
                                              }
                                            }
                                          })
                                        ]
                                      )
                                    ])
                                  ]
                                )
                              ]
                            }
                          },
                          _vm._l(_vm.rows, function(row, key) {
                            return {
                              key: "table-row",
                              fn: function(props) {
                                return [
                                  _c("div", { key: key }, [
                                    props.column.field == "action"
                                      ? _c(
                                          "div",
                                          [
                                            _c(
                                              "router-link",
                                              {
                                                staticClass:
                                                  "btn edit-btn-vvg waves-effect",
                                                attrs: {
                                                  title: "Edit Part Detail",
                                                  to: {
                                                    name: "UpdateInventoryPart",
                                                    params: {
                                                      inventory_id:
                                                        props.row.inventory_id,
                                                      id: props.row.id
                                                    }
                                                  }
                                                }
                                              },
                                              [
                                                _c("i", {
                                                  staticClass: "fa fa-pencil",
                                                  attrs: {
                                                    "aria-hidden": "true"
                                                  }
                                                })
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      : props.column.field ==
                                        "inventory_part_mapper_bin_location"
                                      ? _c(
                                          "div",
                                          [
                                            _vm.isEditBinLocation
                                              ? [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          props.row
                                                            .inventory_part_mapper_bin_location,
                                                        expression:
                                                          "props.row.inventory_part_mapper_bin_location"
                                                      }
                                                    ],
                                                    attrs: { type: "text" },
                                                    domProps: {
                                                      value:
                                                        props.row
                                                          .inventory_part_mapper_bin_location
                                                    },
                                                    on: {
                                                      blur: function($event) {
                                                        return _vm.addUpdateBinLocation(
                                                          props.row.id,
                                                          props.row
                                                            .inventory_part_mapper_bin_location
                                                        )
                                                      },
                                                      input: function($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        ) {
                                                          return
                                                        }
                                                        _vm.$set(
                                                          props.row,
                                                          "inventory_part_mapper_bin_location",
                                                          $event.target.value
                                                        )
                                                      }
                                                    }
                                                  })
                                                ]
                                              : [
                                                  _vm._v(
                                                    "\n                                        " +
                                                      _vm._s(
                                                        props.formattedRow[
                                                          "inventory_part_mapper_bin_location"
                                                        ]
                                                      ) +
                                                      "\n                                    "
                                                  )
                                                ]
                                          ],
                                          2
                                        )
                                      : _c("div", [
                                          props.column.field !=
                                          "inventory_part_mapper_bin_location"
                                            ? _c("div", [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(
                                                      props.formattedRow[
                                                        props.column.field
                                                      ]
                                                    ) +
                                                    "\n                                    "
                                                )
                                              ])
                                            : _vm._e()
                                        ])
                                  ])
                                ]
                              }
                            }
                          }),
                          {
                            key: "selected-row-actions",
                            fn: function(computed) {
                              return _c("div", {}, [
                                _vm._v(
                                  "\n\t\t\t\t\t\t\t" +
                                    _vm._s(computed.selectedRows) +
                                    "\n\t\t\t\t\t\t\t"
                                ),
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-success",
                                    attrs: {
                                      disabled: _vm.disableButtons.generateAll,
                                      title: "Generate All"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.generateQrcode(true)
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.buttonNames.generateAll) +
                                        "(" +
                                        _vm._s(_vm.totalRecords) +
                                        ")"
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-success",
                                    attrs: {
                                      disabled:
                                        _vm.disableButtons.generateOneByOne,
                                      title: "Generate Selected"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.generateQrcode(false)
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.buttonNames.generateOneByOne) +
                                        "(" +
                                        _vm._s(
                                          _vm.totalRecords > _vm.selectedRows
                                            ? _vm.selectedRows
                                            : _vm.totalRecords
                                        ) +
                                        ")"
                                    )
                                  ]
                                )
                              ])
                            }
                          }
                        ],
                        null,
                        true
                      )
                    })
                  ],
                  1
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "medium-modal" },
              [
                _c(
                  "b-modal",
                  {
                    ref: "add-edit-backorder-note-modal",
                    staticClass: "modal-section",
                    attrs: {
                      id: "modallg",
                      size: "sg",
                      title: "Import Inventory Location From Excel"
                    }
                  },
                  [
                    _c(
                      "form",
                      {
                        attrs: {
                          id: "modalForm",
                          enctype: "multipart/form-data"
                        }
                      },
                      [
                        _c("div", { staticClass: "modal-body" }, [
                          _vm._v(
                            "\n                            Select Excel File to Import Inventory Location\n                            "
                          ),
                          _c("input", {
                            ref: "files",
                            attrs: {
                              type: "file",
                              name: "excl_file",
                              accept: ".xlsx,.xls",
                              id: "uploadInventoryFile"
                            },
                            on: {
                              change: function($event) {
                                return _vm.handleFilesUpload()
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "form-group" }, [
                            _c("label", {
                              staticClass: "error",
                              attrs: { id: "errorMsg" }
                            }),
                            _c("br")
                          ]),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              staticClass:
                                "btn general-button btn-info waves-effect m-r-20",
                              attrs: {
                                id: "demourl",
                                href: "demoUrl",
                                target: "_blank"
                              }
                            },
                            [
                              _vm._v(
                                "\n                                Download Demo\n                            "
                              )
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "modal-footer" }, [
                          _c(
                            "button",
                            {
                              staticClass:
                                "btn general-button btn-success waves-effect",
                              attrs: { type: "button", id: "invImportBtn" },
                              on: {
                                click: function($event) {
                                  return _vm.importInventory($event)
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.importBtn))]
                          )
                        ])
                      ]
                    )
                  ]
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("app-footer")
        ],
        1
      )
    : _c("div", [_c("no-permission")], 1)
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4833bd0d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4833bd0d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Inventory/ListCustomerInventory.vue
// module id = null
// module chunks = 